/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorMostRead as ResolvedLabradorMostRead } from 'base/components/labrador/MostRead';

export const LabradorMostRead: typeof ResolvedLabradorMostRead = withLabradorInstanceof((props) => {
    return <ResolvedLabradorMostRead {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorMostReadProps = PropsFromComponent<typeof LabradorMostRead>;
